import apiClient from './config';

// --- REGISTER ---
export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post('/register', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

// --- VERIFY REGISTRATION ---
export const verifyUser = async (data) => {
  try {
    const response = await apiClient.post('/verify', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Verification Error' };
  }
};

// --- LOGIN (Direct Authentication) ---
export const loginUser = async (credentials) => {
  try {
    const response = await apiClient.post('/login', credentials);
    // Returns: { success: true, token: "...", data: user }
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Login Error' };
  }
};

// --- ✅ LOGIN STEP 2 (Verify OTP) ---
export const verifyLoginOtp = async (data) => {
  try {
    // data = { email, code }
    const response = await apiClient.post('/login-verify', data);
    // Returns: { success: true, data: user } (Cookie is set automatically)
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Invalid OTP' };
  }
};

// --- LOGOUT ---
export const logoutUser = async () => {
  try {
    const response = await apiClient.get('/logout');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Logout Error' };
  }
};

// --- GET CURRENT USER ---
export const fetchCurrentUser = async () => {
  try {
    const response = await apiClient.get('/me');
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Not authorized' };
  }
};

// ============================================================
//  FORGOT PASSWORD SERVICES
// ============================================================

// --- STEP 1: Send OTP ---
export const sendForgotPasswordOtp = async (data) => {
  try {
    // data = { email }
    const response = await apiClient.post('/forgot-password', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to send OTP' };
  }
};

// --- STEP 2: Verify OTP ---
export const verifyForgotPasswordOtp = async (data) => {
  try {
    // data = { email, code: otp }
    const response = await apiClient.post('/forgot-password-verify', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Invalid OTP' };
  }
};

// --- STEP 3: Reset Password ---
export const resetPassword = async (data) => {
  try {
    // data = { email, otp, newPassword }
    const response = await apiClient.post('/reset-password', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to reset password' };
  }
};

// ============================================================
//  ✅ NEW: PROFILE UPDATES (Authenticated)
// ============================================================

// --- Update Password (Logged In) ---
export const updateMyPassword = async (data) => {
  try {
    // data = { currentPassword, newPassword }
    const response = await apiClient.put('/update-password', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to update password' };
  }
};
